module.exports = __webpack_public_path__ + "static/media/21ECLAC18.1e699607.jpg";